import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Card, Tab, Nav, Badge, NavDropdown, Accordion } from "react-bootstrap";
import '../../../scss/pages/_menu-list.scss';
import menuimg from "../../../images/product/cs.jpg"
import photo1 from "../../../images/img8.jpg"
import photo2 from "../../../images/img6.jpg"
import PageTitle from '../../layouts/PageTitle';
import AddMenu from './add.component';
import addCategory from './category.component';
import { Alert } from '@mui/material';
import Switch from '@mui/material/Switch';


import {
    getItemAction
} from '../../../store/actions/ItemActions';

import { useDispatch, useSelector } from 'react-redux';





const MenueList = () => {

    const dispatch = useDispatch();

    const allItems = useSelector((state) => state.allItems?.items?.payload);

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    const [request, setRequest] = useState('daily');


    const [title, setTitle] = useState('');
    const [categoryid, setCategoryid] = useState(0);
    const [details, setDetails] = useState(false);
    const [component, setComponet] = useState("");
    
    console.log(allItems);

    function fetchAllItems() {
        dispatch(getItemAction());
    }

    useEffect(() => {
        fetchAllItems();
    }, []);


    const handleDetailsSidebar = (action, item, menuTitle, id) => {
        if (action === "open") {
            setDetails(true)
            setComponet(item);
            setTitle(menuTitle);
            setCategoryid(id);
        }
        else {
            setDetails(false)
        }
    }

   

    return (
        <div className='menu'>
            <PageTitle
                title="Menu Management"
                subtitle="Edit your offerings by easliy changing anything about your menu below "
            />
            <div className="row w-100 menu-top ml-0">
                <div className="col-md-10 col-lg-10">
                    <div className="d-flex align-items-center">
                        <i className='mdi mdi-information fs-5'> </i>
                        <small className='ml-2'> Please review your menu and clicks 'Confirm Menu' when you are ready. You can edit and add your missing items. Restaurants usually take 1-2 working days to complete </small>
                    </div>
                </div>
                <div className="col-md-2 col-lg-2 justify-content-end text-right pr-0">
                    <button className='btn btn-sm btn-success rounded-0 py-1'>Confirm Menu</button>
                </div>
            </div>
            <div className="d-flex justify-content-end mt-4 menu-copy">
                <i className='mdi mdi-content-copy'></i>
                <small className='ml-1 text'>COPY TO OUTLETS</small>
            </div>
            <Row>
                <Col sm={3} className='pr-0'>
                    <div className='card rounded-0'>
                        <div className='card-body left-card'>

                            <button onClick={() => setRequest('daily')} class="btn btn-link btn-block text-left p-0 mb-2" type="button" data-toggle="collapse" data-target="#dailyMenu" aria-expanded="true" aria-controls="dailyMenu">
                                <span style={{ color: 'black', fontSize: '13px', marginBottom: '15px' }}> <i className="mdi mdi-book-open-variant mdi-18px" style={{ color: '#2685d2' }}></i> <b>Daily Menu</b></span>
                            </button>

                            <div id="dailyMenu" className={`${request == 'daily' ? 'collapse show' : 'collapse'}`} aria-labelledby="dailyMenu" data-parent="#accordionExample" data-request={request}>

                                {allItems?.categories?.map(category =>
                                    <button class="btn btn-link btn-block text-left pt-0 mt-0"
                                        style={{ paddingTop: "0" }}
                                        type="button" data-toggle="collapse" data-target={`#collapse${category?.id}`} aria-expanded="true" aria-controls={`collapse${category?.id}`}>{category?.name}</button>

                                )}
                            </div>

                            <button class="btn btn-link btn-block text-left p-0" type="button" data-toggle="collapse" data-target="#chooseGroup" aria-expanded="true" aria-controls="chooseGroup">
                                <span style={{ color: 'black', fontSize: '13px', marginBottom: '15px' }}> <i className="mdi mdi-group mdi-18px" style={{ color: '#adaeaf' }}></i> <b> Choice Groups</b></span>
                            </button>

                            <div id="chooseGroup" class="collapse" aria-labelledby="chooseGroup" data-parent="#accordionExample">
                            </div>

                            <button class="btn btn-link btn-block text-left p-0 mt-2" type="button" data-toggle="collapse" data-target="#request" aria-expanded="true" aria-controls="request">
                                <span style={{ color: 'black', fontSize: '13px', marginBottom: '15px' }}> <i className="mdi mdi-update mdi-18px" style={{ color: '#adaeaf' }}></i> <b>Requests</b></span>
                            </button>

                            <div id="request" class="collapse show  pl-4" aria-labelledby="request" data-parent="#accordionExample">
                                <div onClick={() => setRequest('rejected')} className={`d-flex mt-2 d-flex justify-content-between ${request === 'rejected' && 'request-hoaver'}`}>
                                    <small> <b>Rejected</b> </small>
                                    <span class="badge badge-danger light">0</span>
                                </div>
                                <div onClick={() => setRequest('pending')} className={`d-flex mt-2 d-flex justify-content-between ${request === 'pending' && 'request-hoaver'}`}>
                                    <small><b>Pending</b></small>
                                    <span class="badge badge-warning light">0</span>
                                </div>
                                <div onClick={() => setRequest('approved')} className={`d-flex mt-2 d-flex justify-content-between ${request === 'approved' && 'request-hoaver'}`}>
                                    <small><b>Approved</b> </small>
                                    <span class="badge badge-success light">0</span>
                                </div>
                            </div>
                            <div onClick={() => setRequest('photos')} className='mt-2'>
                                <span style={{ color: 'black', fontSize: '13px' }}> <i className="mdi mdi-image mdi-18px" style={{ color: '#adaeaf' }}></i> <b>Photos</b></span>
                            </div>
                            <div onClick={() => setRequest('notification')} className='mt-2 d-flex justify-content-between align-items-center'>
                                <span style={{ color: 'black', fontSize: '13px' }}> <i className="mdi mdi-bell mdi-18px" style={{ color: '#adaeaf' }}></i> <b>Email Notifications</b></span>
                                <span class="badge badge-danger badge-xs rounded-0 py-0" style={{ height: '20px' }}>New</span>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={9} className='pl-0'>
                    {request === 'daily' && <div className='card rounded-0'>
                        <div className='card-body'>
                            <div className='card-header px-0  pt-0'>
                                <div className='row w-100 m-0'>
                                    <div className='col-md-10 col-lg-10 pl-0'>
                                        <h4 className="card-title">Daily Menu</h4>
                                        <div className='d-flex mt-1'>
                                            <small> Everyday from 12:00 AM - 12:00 AM </small>
                                            {/* <span style={{ color: '#4590d2', marginLeft: '20px' }}> <a>EDIT MENU</a></span> */}
                                        </div>
                                    </div>
                                    <div className='col-md-2 col-lg-2 d-flex justify-content-end pr-0'>
                                        <NavDropdown className='btn btn-sm btn-secondary rounded-0 py-0' title="ADD NEW" id="basic-nav-dropdown">
                                            <NavDropdown.Item onClick={() => handleDetailsSidebar("open", "item", "Add Item")}>
                                                <div className='d-flex'>
                                                    <i className='mdi mdi-select'> </i>
                                                    <span className='ml-4'>Item</span>
                                                </div>
                                            </NavDropdown.Item>
                                            <NavDropdown.Item onClick={() => handleDetailsSidebar("open", "category", "Add Category")}>
                                                <div className='d-flex'>
                                                    <i className='mdi mdi-menu'> </i>
                                                    <span className='ml-4'>Category</span>
                                                </div>
                                            </NavDropdown.Item>
                                            {/* <NavDropdown.Item href="#action/3.3">
                                                <div className='d-flex'>
                                                    <i className='mdi mdi-silverware-variant'> </i>
                                                    <span className='ml-4'>Menu</span>
                                                </div>
                                            </NavDropdown.Item> */}
                                        </NavDropdown>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='card-header py-1 px-0'>
                                    <div class="accordion w-100" id="accordionExample">
                                        {allItems?.categories?.map((category, index) =>
                                            // category?.items?.map(item =>
                                            <div class="card rounded-0">
                                                <div class="card-header rounded-0" id="headingOne">
                                                    <button class="btn btn-link btn-block text-left p-0" type="button" data-toggle="collapse" data-target={`#collapse${category?.id}`} aria-expanded="true" aria-controls={`collapse${category?.id}`}>
                                                        <div className='row'>
                                                            <div className='col-md-9 col-lg-9'>
                                                                {category?.name}
                                                            </div>

                                                        </div>
                                                    </button>
                                                    <div className='float-right d-flex justify-content-end p-0' onClick={() => handleDetailsSidebar("open", "editCategory", "Edit Category", category?.id)} style={{ cursor: "pointer", width: "110px" }} >
                                                        <span style={{ color: '#4590d2' }}>
                                                            EDIT CATEGORY
                                                        </span>
                                                    </div>
                                                </div>
                                                <div onClick={() => handleDetailsSidebar("open", "editItem", "Edit Item")} id={`collapse${category?.id}`} class={`collapse  ${index === 0 && "show"}`} aria-labelledby="headingOne" data-parent="#accordionExample">
                                                    {
                                                        category?.items?.map(item =>
                                                            <div class="card-body rounded-0">
                                                                <div className='dragable-section'>
                                                                    <div className='card-header rounded-0 border-0 p-0'>
                                                                        <div className='row w-100 d-flex align-items-center'>
                                                                            <div className="col-md-10 col-lg-10">
                                                                                <div className="row">
                                                                                    <div className="col-md-1 col-lg-1 d-flex align-items-center">
                                                                                        <i className="fas fa-grip-vertical me-3"></i>
                                                                                    </div>
                                                                                    <div className="col-md-11 col-lg-11 d-flex flex-column justify-content-between">
                                                                                        <div>
                                                                                            <span> {item?.name} </span>
                                                                                            <br />
                                                                                            <small>{item?.description}</small>
                                                                                        </div>
                                                                                        <span className='mt-4'> <b>Tk {item?.price}</b></span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-2 col-lg-2 d-flex text-right">
                                                                                <img className='img-fluid' src={menuimg} alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}


                    {request === 'rejected' &&
                        <div className='card rounded-0'>
                            <div className='card-body'>
                                <div className='card-header px-0  pt-0'>
                                    <div className='row w-100 m-0'>
                                        <div className='col-md-10 col-lg-10 pl-0'>
                                            <h4 className="card-title">Rejected Request (0)</h4>
                                            <small> Select each item to view request details </small>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>

                                </div>
                            </div>
                        </div>
                    }

                    {request === 'pending' &&
                        <div className='card rounded-0'>
                            <div className='card-body'>
                                <div className='card-header px-0  pt-0'>
                                    <div className='row w-100 m-0'>
                                        <div className='col-md-10 col-lg-10 pl-0'>
                                            <h4 className="card-title">Pending Request (0)</h4>
                                            <small> Select each item to view request details </small>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>

                                </div>
                            </div>
                        </div>}

                    {request === 'approved' &&
                        <div className='card rounded-0'>
                            <div className='card-body'>
                                <div className='card-header px-0  pt-0'>
                                    <div className='row w-100 m-0'>
                                        <div className='col-md-10 col-lg-10 pl-0'>
                                            <h4 className="card-title">Approved Request (0)</h4>
                                            <small> Select each item to view request details </small>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>

                                </div>
                            </div>
                        </div>}


                    {request === 'photos' &&
                        <div className='card photo rounded-0'>
                            <div className='card-body'>
                                <div className='card-header px-0  pt-0'>
                                    <div className='row w-100 m-0'>
                                        <div className='col-md-10 col-lg-10 pl-0'>
                                            <h4 className="card-title">Photos</h4>
                                            <small> Update your photos so customers can easily discover and place orders </small>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6 col-lg-6'>
                                        <div className='mt-2'>
                                            <b >Listing photos</b>
                                            <img className='img-fluid mt-2' src={photo1} alt="" />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-lg-6' style={{ position: 'relative' }}>
                                        <div className='mt-2'>
                                            <b>Banner photos</b>
                                            <img className='img-fluid w-100 mt-2' src={photo2} style={{ height: '100px' }} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className='row' style={{ marginTop: '100px' }}>
                                    <Alert severity="info">
                                        What are Listing and Banner photos?

                                        <div className='row mt-3'>
                                            <div className='col-md-6 col-lg-6'>
                                                <p>Listing photos</p>
                                                <img src='' alt='' />
                                            </div>
                                            <div className='col-md-6 col-lg-6'>
                                                <p>Banner photos</p>
                                                <img src='' alt='' />
                                            </div>
                                        </div>

                                    </Alert>
                                </div>
                            </div>
                        </div>}

                    {request === 'notification' &&
                        <div className='card rounded-0'>
                            <div className='card-body'>
                                <div className='card-header px-0  pt-0'>
                                    <div className='row w-100 m-0'>
                                        <div className='col-md-10 col-lg-10 pl-0'>
                                            <h4 className="card-title">Email Notifications</h4>
                                            <small>Receive notifications to sabbir.foodhub.bd for all your outlets.</small>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <p className='fw-bold mt-3'> Menu Change Request</p>
                                    <div className='d-flex mt-2'>
                                        <Switch {...label} />
                                        <p className='mt-2 fs-6' >Receive email Notification for all your outlets when your requests for menu changes are processed. Email will be sent one per day.</p>
                                    </div>
                                </div>
                            </div>
                        </div>}




                </Col>
            </Row>
            <AddMenu
                title={title}
                handleDetailsSidebar={handleDetailsSidebar}
                component={component}
                details={details}
                categoryid={categoryid}
            />

        </div>
    );
};

export default MenueList;